import Hero from './components/Hero/Hero';
import Navbar from './components/Navbar/navbar';
import './App.css'
import Skills from './components/Skills/Skills';
import WorkExperience from './components/WorkExperience/WorkExperience';
import Portfolio from './components/portfolio/Portfolio';
import Contact from './components/contact/Contact';
import Footer from './components/Footer/Footer';


function App() {
  return (
    <div className="App">
     <Navbar/>
     <div className='container'>
      <Hero/>
      <Skills/>
      <Portfolio/>
      <Contact/>
      
     </div>
     <Footer/>
    </div>
  );
}

export default App;
